import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_PARTNERS,
  GPX_ROUTES,
} from '@rsos/gainsight';

// Event names specific to Roadside Assistance (RSA)
const RSA_EVENT_NAMES = {
  RSA_ACTION_BUTTON_CLICK_ON: 'rsa_action_button_click_on',
  RSA_ACTION_BUTTON_CLICK_OFF: 'rsa_action_button_click_off',
  RSA_SEND_MESSAGE_CLICK: 'rsa_send_message_click',
  RSA_LINK_FETCHED: 'rsa_custom_link_fetched',
};

/**
 * Tracks when a user clicks the RSA action button in the Unite action bar.
 */
export const trackRSAActionButtonClickOn = () => {
  gspx.trackEvent({
    name: RSA_EVENT_NAMES.RSA_ACTION_BUTTON_CLICK_ON,
    type: GPX_EVENT_TYPES.CLICK,
    feature: GPX_FEATURES.ROADSIDE_ASSISTANCE,
    capability: GPX_CAPABILITIES.ROADSIDE_ASSISTANCE,
    partner: GPX_PARTNERS.AGERO,
    route: GPX_ROUTES.MAP,
  });
};
/**
 * Tracks when a user clicks the RSA action button in the Unite action bar.
 */
export const trackRSAActionButtonClickOff = () => {
  gspx.trackEvent({
    name: RSA_EVENT_NAMES.RSA_ACTION_BUTTON_CLICK_OFF,
    type: GPX_EVENT_TYPES.CLICK,
    feature: GPX_FEATURES.ROADSIDE_ASSISTANCE,
    capability: GPX_CAPABILITIES.ROADSIDE_ASSISTANCE,
    partner: GPX_PARTNERS.AGERO,
    route: GPX_ROUTES.MAP,
  });
};

/**
 * Tracks when a user clicks the Send button after completing the message modal.
 * @param {Object} params - Parameters for the send button event
 * @param {string} params.phoneNumber - The phone number to which the message was sent
 */
export const trackRSASendMessageClick = ({ phoneNumber }) => {
  gspx.trackEvent({
    name: RSA_EVENT_NAMES.RSA_SEND_MESSAGE_CLICK,
    type: GPX_EVENT_TYPES.CLICK,
    feature: GPX_FEATURES.ROADSIDE_ASSISTANCE,
    capability: GPX_CAPABILITIES.ROADSIDE_ASSISTANCE,
    partner: GPX_PARTNERS.AGERO,
    route: GPX_ROUTES.MAP,
    entities: {
      phone_number: phoneNumber,
    },
  });
};

/**
 * Tracks how many times a custom RSA link is fetched (triggered by phone number input).
 * @param {Object} params - Parameters for the RSA link fetch event
 * @param {string} params.phoneNumber - The input phone number triggering the fetch
 * @param {string} params.roadsideAssistanceUrl - The URL from the fetch
 */
export const trackRSACustomLinkFetched = ({
  phoneNumber,
  roadsideAssistanceUrl,
}) => {
  gspx.trackEvent({
    name: RSA_EVENT_NAMES.RSA_LINK_FETCHED,
    type: GPX_EVENT_TYPES.API_PUSH,
    feature: GPX_FEATURES.ROADSIDE_ASSISTANCE,
    capability: GPX_CAPABILITIES.ROADSIDE_ASSISTANCE,
    partner: GPX_PARTNERS.AGERO,
    route: GPX_ROUTES.MAP,
    entities: {
      phone_number: phoneNumber,
      roadside_assistance_url: roadsideAssistanceUrl,
    },
  });
};
